.bo{max-width:100%;}